import {
	APPROVE_TEMPLATE, APPROVE_TEMPLATE_FAILED, APPROVE_TEMPLATE_SUCCESS,
	DENY_TEMPLATE, DENY_TEMPLATE_FAILED, DENY_TEMPLATE_SUCCESS,
	GET_TEMPLATES, GET_TEMPLATES_SUCCESS, GET_TEMPLATES_FAILED,
	GET_TEMPLATE_DETAIL, GET_TEMPLATE_DETAIL_SUCCESS, GET_TEMPLATE_DETAIL_FAILED,
	SAVE_TEMPLATE, SAVE_TEMPLATE_SUCCESS, SAVE_TEMPLATE_FAILED,
	DOWNLOAD_TEMPLATE, DOWNLOAD_TEMPLATE_SUCCESS, DOWNLOAD_TEMPLATE_FAILED,
	DELETE_TEMPLATE, DELETE_TEMPLATE_SUCCESS, DELETE_TEMPLATE_FAILED, REFRESH_ALL
} from './template.actions';
import { IAction, ITemplate, ITemplateState } from '../../types/types';

const initialState: ITemplateState = {
	isLoading: false,
	templates: [] as ITemplate[],
	selectedTemplate: {} as ITemplate,
	error: null,
	templateStatusId: 0,
	isDownloading: false,
	approveTemplateResponse: undefined,
	denyTemplateResponse: undefined,
	needsRefresh: false
}

const mainProcess = (state = initialState, { type, payload }: IAction) => {
	switch (type) {
		case GET_TEMPLATES:
			return {
				...state,
				isLoading: true
			}
		case GET_TEMPLATES_SUCCESS:
			return {
				...state,
				isLoading: false,
				templates: payload
			}
		case GET_TEMPLATES_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload
			}


		case GET_TEMPLATE_DETAIL:
			return {
				...state,
				isLoading: true
			}
		case GET_TEMPLATE_DETAIL_SUCCESS:
			return {
				...state,
				isLoading: false,
				selectedTemplate: payload
			}
		case GET_TEMPLATE_DETAIL_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload
			}

		case SAVE_TEMPLATE:
			return {
				...state,
				isLoading: true
			}
		case SAVE_TEMPLATE_SUCCESS:
			return {
				...state,
				isLoading: false,
				templateDetail: payload,
				saveSuccess: true
			}
		case SAVE_TEMPLATE_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload,
				saveSuccess: false
			}

		case DOWNLOAD_TEMPLATE:
			return {
				...state,
				isDownloading: true
			}
		case DOWNLOAD_TEMPLATE_SUCCESS:
			return {
				...state,
				isDownloading: false
			}
		case DOWNLOAD_TEMPLATE_FAILED:
			return {
				...state,
				isDownloading: false,
				error: payload
			}
		case APPROVE_TEMPLATE:
			return {
				...state,
				isLoading: true
			}
		case APPROVE_TEMPLATE_SUCCESS:
			return {
				...state,
				isLoading: false,
				approveTemplateResponse: payload,
				needsRefresh: true
			}
		case APPROVE_TEMPLATE_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload
			}
		case DENY_TEMPLATE:
			return {
				...state,
				isLoading: true
			}
		case DENY_TEMPLATE_SUCCESS:
			return {
				...state,
				isLoading: false,
				denyTemplateResponse: payload,
				needsRefresh: true
			}
		case DENY_TEMPLATE_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload
			}
		case DELETE_TEMPLATE:
			return {
				...state,
				isLoading: true
			}
		case DELETE_TEMPLATE_SUCCESS:
			return {
				...state,
				isLoading: false,
				needsRefresh: true
			}
		case DELETE_TEMPLATE_FAILED:
			return {
				...state,
				isLoading: false,
				error: payload
			}
		case REFRESH_ALL:
			return {
				...state,
				needsRefresh: true
			}
		default:
			return state;
	}
}

export default mainProcess;